module.exports = __webpack_public_path__ + "static/media/search-black.3c4da0ee.svg";